import { Grid } from '@material-ui/core';
import React from 'react';
import CustomCard from '../../shared/CustomCard';
import ReactInfiniteScroll from '../../common/ReactInfiniteScroll';

const DealershipList = ({ filteredDealershipArray, data, handleDataChange }) => (
  <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
    <ReactInfiniteScroll
      size={20}
      data={filteredDealershipArray}
      height="300px"
      renderItem={(dealership) => (
        <Grid item xs={4} key={dealership.hash}>
          <Grid item>
            <CustomCard
              id={dealership.id}
              name="dealerships"
              checkbox
              menu={false}
              title={dealership.name}
              subTitle={`Dealership ID : ${dealership.id}`}
              thirdTitle={`${dealership.employeeCount} Employees`}
              width="321px"
              height="80px"
              status={dealership.enabled}
              selected={
                data?.dealerships?.includes(dealership.id) || data?.dealerships?.includes(dealership.id.toString())
              }
              handleChange={handleDataChange}
            />
          </Grid>
        </Grid>
      )}
    />
  </Grid>
);

export default React.memo(DealershipList);
